import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SommaAssicurataFormComponent } from './form/form.component';
import { SommeAssicurateComponent } from './somme-assicurate.component';

const routes: Routes = [
  {
    path: '', component: SommeAssicurateComponent
  },
  {
    path: 'inserisci', component: SommaAssicurataFormComponent,
    data: { title: 'Inserimento Somme Assicurate' },
  },
  {
    path: ':idSommaAssicurata', component: SommaAssicurataFormComponent,
    data: { title: 'Visualizazzione Somma Assicurata' },
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SommeAssicurateRoutingModule { }
